<template functional>
  <div class="loader-wrapper" :class="{ '-opacity': props.opacity }">
    <div class="loader-wrapper__loader">
      <div class="loader">
        <svg class="svg" viewBox="138 235 100 100">
          <path
            class="logo"
            fill="none"
            stroke="white"
            stroke-width="5"
            d="M161,322.6l6-74.7c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1l20.7,74.4c0,0.1,0.1,0.1,0.1,0.1
								c0,0,0.1,0,0.1-0.1l20.6-74.4c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1l6.1,74.7l0,0h-50.7c-7.7,0-14-6.3-14-14v-47.3
								c0-7.7,6.3-14,14-14h47.3c7.7,0,14,6.3,14,14V312c0,5.9-4.8,10.6-10.6,10.6l0,0l0,0"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    opacity: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #3c445a;
  z-index: 9999;

  &__loader {
    width: 90%;
    @include pos-centered;

    .loader {
      width: 10em;
      height: 10em;
      margin: auto;
      margin-top: 30vh;
    }

    .svg {
      width: 10em;
      height: 10em;
    }

    .logo {
      stroke-dasharray: 584;
      stroke-dashoffset: 584;
      animation: loader 5s ease-in-out alternate infinite;
    }

    @keyframes loader {
      from {
        stroke-dashoffset: 584;
      }
      to {
        stroke-dashoffset: 0;
      }
    }
  }

  &.-opacity {
    opacity: 0.5;
  }
}
</style>
